import { productCatalog } from 'Bomdisoft/shared/products/catalog';
import { productsNavAllProducts, productsNavOverview, productsPageTitle } from 'Bomdisoft/translations';
import type { DocsNavGroup } from '@bomdisoft/components/docs';

export const productsNav: DocsNavGroup[] = [
  {
    heading: lang => productsNavOverview[lang],
    items: [{ href: langPrefix => `/${langPrefix}/products`, label: lang => productsNavAllProducts[lang], testId: 'nav-link-products-index' }],
    testId: 'products-nav-overview',
  },
  {
    heading: lang => productsPageTitle[lang],
    items: productCatalog.map(product => ({
      href: (langPrefix: string) => `/${langPrefix}/products/${product.slug}`,
      label: () => product.name,
      testId: `nav-link-products-${product.slug}`,
    })),
    testId: 'products-nav-products',
  },
];
